export default class Provider {
    constructor() {
        this.id;
        this.practiceNumber;
        this.bhfNumber;
        this.practiceName;
        this.doctorName;
        this.emailAddress;
        this.cellNumber;
        this.addressLine1;
        this.addressLine2;
        this.addressLine3;
        this.addressPostalCode;
        this.generateDocuments;
        this.joinDate;
        this.lastSynced;
        this.currentBatchId;
        this.numberOfUnResolvedQueries;
        this.proxyDocumentId;
        this.adminFeePercentage;
        this.prefundFeePercentage;
        this.providerGroupId;
        this.areaIds;
        this.providerFiles = [];
        this.isVatRegistered;
        this.vatNumber;
        this.primaryDiscipline;
        this.disciplines;
        this.caseReviewDays = 14;
        this.caseReviewBusinessDaysOnly = true;
        this.paymentDueDays = 30;
        this.paymentDueBusinessDaysOnly = false;
        this.providerEmails = [];
        this.isAccicareAdmittanceFacility;
        this.bankName;        
        this.accountName;
        this.accountNo;
        this.branchCode;
        this.branchName;
        this.isActive;
        this.raf21SupplierDetailsEmail;
        this.raf23BankAccountSupplierRepresentativeAccountNumber;
        this.raf23BankAccountBankRepresentativeName;
        this.raf23BankAccountBranchRepresentativeCode;
        this.raf23BankAccountNameOfRepresentativeAccountHolder;
        this.raf211DeclarationSignedAt;
        this.useRaf2Defaults;
        this.raf211SignatureFileId;
        this.raf211StampFileId;
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.practiceNumber = setEntity.practiceNumber;
        this.bhfNumber = setEntity.bhfNumber;
        this.practiceName = setEntity.practiceName;
        this.doctorName = setEntity.doctorName;
        this.emailAddress = setEntity.emailAddress;
        this.cellNumber = setEntity.cellNumber;
        this.addressLine1 = setEntity.addressLine1;
        this.addressLine2 = setEntity.addressLine2;
        this.addressLine3 = setEntity.addressLine3;
        this.addressPostalCode = setEntity.addressPostalCode;
        this.generateDocuments = setEntity.generateDocuments;
        this.joinDate = setEntity.joinDate;
        this.lastSynced = setEntity.lastSynced;
        this.currentBatchId = setEntity.currentBatchId;
        this.numberOfUnResolvedQueries = setEntity.numberOfUnResolvedQueries;
        this.proxyDocumentId = setEntity.proxyDocumentId;
        this.adminFeePercentage = setEntity.adminFeePercentage;
        this.prefundFeePercentage = setEntity.prefundFeePercentage;
        this.areaIds = setEntity.areaIds;
        this.providerGroupId = setEntity.providerGroupId;
        this.providerFiles = setEntity.providerFiles ? setEntity.providerFiles : [];
        this.isVatRegistered = setEntity.isVatRegistered;
        this.vatNumber = setEntity.vatNumber;
        this.primaryDiscipline = setEntity.primaryDiscipline;
        this.disciplines = setEntity.disciplines ? setEntity.disciplines : [];
        this.caseReviewDays = setEntity.caseReviewDays;
        this.caseReviewBusinessDaysOnly = setEntity.caseReviewBusinessDaysOnly;
        this.paymentDueDays = setEntity.paymentDueDays;
        this.paymentDueBusinessDaysOnly = setEntity.paymentDueBusinessDaysOnly;
        this.providerEmails = setEntity.providerEmails ? setEntity.providerEmails : [];
        this.isAccicareAdmittanceFacility = setEntity.isAccicareAdmittanceFacility;
        this.branchName = setEntity.branchName;
        this.accountNo = setEntity.accountNo;
        this.bankName = setEntity.bankName;
        this.accountName = setEntity.accountName;
        this.branchCode = setEntity.branchCode;
        this.isActive = setEntity.isActive;
        this.raf21SupplierDetailsEmail = setEntity.raf21SupplierDetailsEmail;
        this.raf23BankAccountSupplierRepresentativeAccountNumber = setEntity.raf23BankAccountSupplierRepresentativeAccountNumber;
        this.raf23BankAccountBankRepresentativeName = setEntity.raf23BankAccountBankRepresentativeName;
        this.raf23BankAccountBranchRepresentativeCode = setEntity.raf23BankAccountBranchRepresentativeCode;
        this.raf23BankAccountNameOfRepresentativeAccountHolder = setEntity.raf23BankAccountNameOfRepresentativeAccountHolder;
        this.raf211DeclarationSignedAt = setEntity.raf211DeclarationSignedAt;
        this.useRaf2Defaults = setEntity.useRaf2Defaults;
        this.raf211SignatureFileId = setEntity.raf211SignatureFileId;
        this.raf211StampFileId = setEntity.raf211StampFileId;

        if (this.emailAddress) this.emailAddress = this.emailAddress.replace(/^\n|\n$/g, "");

        return this;
    }
}
